import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/*
 * tailwind-merge only knows the radius names Tailwind ships with, so without
 * this extension `cn(PANEL, 'rounded-frame')` keeps both classes and the winner
 * is decided by CSS source order rather than by the call site. Colour tokens
 * (bg-surface-2, text-ink) need no such help — v4 colour groups accept any
 * value. The four names are the app-surface radius scale in src/app.css.
 */
const merge = extendTailwindMerge({
	extend: {
		classGroups: {
			rounded: [{ rounded: ["chip", "control", "panel", "frame"] }],
		},
	},
});

export const cn = (...inputs: ClassValue[]): string => {
	return merge(clsx(inputs));
};
